export const initAccordion = () => {
  const lists = [...document.querySelectorAll('.js-accordion-list')]
  if (lists.length <= 0) { return false }

  lists.forEach(list => {
    list.querySelector('.question').addEventListener('click', () => {
      list.classList.toggle('is-active')
    })
  })
}
